import JOURNEY_PAGES_V9 from './v9';

export const JOURNEY_VERSION_KEY = 'CURRENT_JOURNEY_VERSION';
export const DEFAULT_JOURNEY_VERSION = 'v9';

export type JOURNEY_VERSION = 'v9';

export const setJourneyVersion = (version: JOURNEY_VERSION) => {
  localStorage.setItem(JOURNEY_VERSION_KEY, version);
};
export const clearJourneyVersion = () => {
  localStorage.removeItem(JOURNEY_VERSION_KEY);
};
export const getJourneyVersion = (): JOURNEY_VERSION => {
  return DEFAULT_JOURNEY_VERSION;
};
export const getJourneyVersionViaPathname = (): JOURNEY_VERSION => {
  return DEFAULT_JOURNEY_VERSION;
};

// final utility
export const GET_JOURNEY_PAGES = () => {
  const JOURNEY_VERSION_MAP = {
    v9: JOURNEY_PAGES_V9,
  };

  return JOURNEY_VERSION_MAP[DEFAULT_JOURNEY_VERSION as keyof typeof JOURNEY_VERSION_MAP];
};
